import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-docoment-list',
  templateUrl: './docoment-list.component.html',
  styleUrl: './docoment-list.component.css'
})
export class DocomentListComponent {
  dummyData = [
    { key: 'layout_plan_approval', type: 'file', label: 'Layout & Building Plan Approval', value: 'Layout & Building Plan Approval.pdf' },
    { key: 'construction_license', type: 'file', label: 'Development/Construction License', value: 'Development/Construction License.pdf' },
    { key: 'zoning_plan_approval', type: 'file', label: 'Demarcation/Zoning Plan Approval', value: 'Demarcation/Zoning Plan Approval.pdf' },
    { key: 'environment_clearance', type: 'file', label: 'Environment Clearance', value: 'Environment Clearance.pdf' },
    { key: 'tree_noc', type: 'file', label: 'NOC for Tree Cutting', value: 'NOC for Tree Cutting.pdf' },
    { key: 'drainage_noc', type: 'file', label: 'NOC for Drainage & Sewerage', value: 'NOC for Drainage & Sewerage.pdf' },
    { key: 'electrical_scheme', type: 'file', label: 'Electrical Scheme Approval', value: 'Electrical Scheme Approval.pdf' },
    { key: 'traffic_noc', type: 'file', label: 'NOC for Traffic & Coordination', value: 'NOC for Traffic & Coordination.pdf' },
    { key: 'fire_scheme', type: 'text', label: 'Fire Fighting Scheme Approval', value: 'Approved by Fire Department' },
    { key: 'monument_approval', type: 'file', label: 'Ancient Monument Approval', value: 'Ancient Monument Approval.pdf' },
    { key: 'consent_establish_operate', type: 'file', label: 'Consent to Establish & Operate', value: 'Consent to Establish & Operate.pdf' },
    { key: 'borewell_certificate', type: 'file', label: 'Borewell Registration Certificate', value: 'Borewell Registration Certificate.pdf' },
    { key: 'excavation_approval', type: 'file', label: 'Excavation/Mining Approval', value: 'Excavation/Mining Approval.pdf' },
    { key: 'infra_approval', type: 'file', label: 'Infrastructure Layout & Common Facilities Approval', value: 'Infrastructure Layout & Common Facilities Approval.pdf' },
    { key: 'road_access_approval', type: 'file', label: 'Road Access Plan Approval', value: 'Road Access Plan Approval.pdf' },
    { key: 'lift_approval', type: 'file', label: 'Lift/Escalator Installation Approval', value: 'Lift/Escalator Installation Approval.pdf' },
    { key: 'electrical_load_sanction', type: 'file', label: 'Sanction of Electrical Load & DG/Transformer Approval', value: 'Sanction of Electrical Load & DG/Transformer Approval.pdf' },
    { key: 'employer_registration', type: 'file', label: 'Registration of Principal Employer', value: 'Registration of Principal Employer.pdf' },
    { key: 'welfare_board_registration', type: 'file', label: 'Registration with Construction Workers Welfare Board', value: 'Registration with Construction Workers Welfare Board.pdf' },
    { key: 'site_office_approval', type: 'file', label: 'Site Office Approval', value: 'Site Office Approval.pdf' },
    { key: 'hoarding_approval', type: 'file', label: 'Hoarding Approval', value: 'Hoarding Approval.pdf' },
    { key: 'iod_certificate', type: 'file', label: 'Intimation of Disapproval (IoD)/Commencement Certificate', value: '' },
    { key: 'ownership_certificate', label: 'Ownership Certificate/Extract', type: 'file', value: 'ownership_certificate.pdf' },
    { key: 'non_encumbrance_certificate', label: 'Non-Encumbrance Certificate (NEC)', type: 'file', value: 'non_encumbrance_certificate.pdf' },
    { key: 'land_use_change', label: 'Change in Land Use (CLU)/Non-Agriculture (NA) Permission', type: 'text', value: 'CLU granted on 2023-10-01' },
    { key: 'airport_clearance', label: 'Airport Clearance', type: 'file', value: 'airport_clearance.pdf' },
    { key: 'crz_clearance', label: 'Coastal Regulatory Zone (CRZ) Clearance', type: 'file', value: 'crz_clearance.pdf' },
    { key: 'completion_certificate', label: 'Completion Certificate (CC)', type: 'file', value: 'completion_certificate.pdf' },
    { key: 'permanent_power_connection', label: 'Permanent Power Connection', type: 'file', value: 'permanent_power_connection.pdf' },
    { key: 'permanent_water_sewage', label: 'Permanent Water and Sewerage Connection', type: 'file', value: 'permanent_water_sewage.pdf' },
    { key: 'rwa_registration', label: 'Registration of RWA', type: 'file', value: 'rwa_registration.pdf' },
    { key: 'occupancy_certificate', label: 'Occupancy Certificate (OC)', type: 'file', value: 'occupancy_certificate.pdf' },
    { key: 'commercial_zoning_approval', label: 'Commercial Zoning Approval', type: 'file', value: 'commercial_zoning_approval.pdf' },
    { key: 'signage_approval', label: 'Signage Approval', type: 'file', value: 'signage_approval.pdf' },
    { key: 'enhanced_fire_safety_standards_clearance', label: 'Enhanced Fire Safety Standards Clearance', type: 'file', value: 'fire_safety_standards.pdf' },
    { key: 'parking_requirements_approval', label: 'Parking Requirements Approval', type: 'file', value: 'parking_approval.pdf' },
    { key: 'accessibility_standards_compliance', label: 'Accessibility Standards Compliance', type: 'file', value: 'accessibility_compliance.pdf' },
    { key: 'commercial_zoning_approval_office', label: 'Commercial Zoning Approval', type: 'file', value: 'office_zoning_approval.pdf' },
    { key: 'fire_safety_approval_multi_storey', label: 'Enhanced Fire Safety Approval for multi-storey setups', type: 'file', value: 'multi_storey_fire_safety.pdf' },
    { key: 'accessibility_compliance_office', label: 'Accessibility Compliance', type: 'file', value: 'office_accessibility.pdf' },
    { key: 'parking_plan_approval', label: 'Parking Plan Approval', type: 'file', value: 'parking_plan.pdf' },
    { key: 'electrical_load_approval', label: 'Electrical Load Approval for office-specific infrastructure', type: 'file', value: 'electrical_load_approval.pdf' },
    { key: 'educational_board_standards_compliance', label: 'Educational Board Standards Compliance (e.g. class size, labs, playgrounds)', type: 'file', value: 'edu_board_compliance.pdf' },
    { key: 'noc_department_of_education', label: 'NOC from Department of Education (DOE)', type: 'file', value: 'noc_doe.pdf' },
    { key: 'recognition_certificate_post_construction', label: 'Recognition Certificate after construction', type: 'file', value: 'recognition_certificate.pdf' },
    { key: 'affiliation_approval', label: 'Affiliation Approval (e.g. CBSE/ICSE)', type: 'file', value: 'affiliation_cbse_icse.pdf' }
  ];

  sanctionFields = [
    { key: 'layout_plan_approval', label: 'Layout & Building Plan Approval', type: 'file' },
    { key: 'construction_license', label: 'Development/Construction License', type: 'file' },
    { key: 'zoning_plan_approval', label: 'Demarcation/Zoning Plan Approval', type: 'file' },
    { key: 'environment_clearance', label: 'Environment Clearance', type: 'file' },
    { key: 'tree_noc', label: 'NOC for Tree Cutting', type: 'file' },
    { key: 'drainage_noc', label: 'NOC for Drainage & Sewerage', type: 'file' },
    { key: 'electrical_scheme', label: 'Electrical Scheme Approval', type: 'file' },
    { key: 'traffic_noc', label: 'NOC for Traffic & Coordination', type: 'file' },
    { key: 'fire_scheme', label: 'Fire Fighting Scheme Approval', type: 'text' },
    { key: 'monument_approval', label: 'Ancient Monument Approval', type: 'file' },
    { key: 'consent_establish_operate', label: 'Consent to Establish & Operate', type: 'file' },
    { key: 'borewell_certificate', label: 'Borewell Registration Certificate', type: 'file' },
    { key: 'excavation_approval', label: 'Excavation/Mining Approval', type: 'file' },
    { key: 'infra_approval', label: 'Infrastructure Layout & Common Facilities Approval', type: 'file' },
    { key: 'road_access_approval', label: 'Road Access Plan Approval', type: 'file' },
    { key: 'lift_approval', label: 'Lift/Escalator Installation Approval', type: 'file' },
    { key: 'electrical_load_sanction', label: 'Sanction of Electrical Load & DG/Transformer Approval', type: 'file' },
    { key: 'employer_registration', label: 'Registration of Principal Employer', type: 'file' },
    { key: 'welfare_board_registration', label: 'Registration with Construction Workers Welfare Board', type: 'file' },
    { key: 'site_office_approval', label: 'Site Office Approval', type: 'file' },
    { key: 'hoarding_approval', label: 'Hoarding Approval', type: 'file' },
    { key: 'iod_certificate', label: 'Intimation of Disapproval (IoD)/Commencement Certificate', type: 'file' }
  ];
  feasibilityFields = [
    { key: 'ownership_certificate', label: 'Ownership Certificate/Extract', type: 'file', value: 'Ownership Certificate/Extract' },
    { key: 'non_encumbrance_certificate', label: 'Non-Encumbrance Certificate (NEC)', type: 'file', value: 'Non-Encumbrance Certificate (NEC)' },
    { key: 'land_use_change', label: 'Change in Land Use (CLU)/Non-Agriculture (NA) Permission', type: 'text', value: 'Change in Land Use (CLU)/Non-Agriculture (NA) Permission' },
    { key: 'airport_clearance', label: 'Airport Clearance', type: 'file', value: 'Airport Clearance' },
    { key: 'crz_clearance', label: 'Coastal Regulatory Zone (CRZ) Clearance', type: 'file', value: 'Coastal Regulatory Zone (CRZ) Clearance' }
  ];
  completionFields = [
    { key: 'completion_certificate', label: 'Completion Certificate (CC)', type: 'file', value: 'Completion Certificate (CC)' },
    { key: 'permanent_power_connection', label: 'Permanent Power Connection', type: 'file', value: 'Permanent Power Connection' },
    { key: 'permanent_water_sewage', label: 'Permanent Water and Sewerage Connection', type: 'file', value: 'Permanent Water and Sewerage Connection' },
    { key: 'rwa_registration', label: 'Registration of RWA', type: 'file', value: 'Registration of RWA' },
    { key: 'occupancy_certificate', label: 'Occupancy Certificate (OC)', type: 'file', value: 'Occupancy Certificate (OC)' }
  ];
  CommercialFields = [
    { key: 'commercial_zoning_approval', label: 'Commercial Zoning Approval', type: 'file', value: '' },
    { key: 'signage_approval', label: 'Signage Approval', type: 'file', value: '' },
    { key: 'enhanced_fire_safety_standards_clearance', label: 'Enhanced Fire Safety Standards Clearance', type: 'file', value: '' },
    { key: 'parking_requirements_approval', label: 'Parking Requirements Approval', type: 'file', value: '' },
    { key: 'accessibility_standards_compliance', label: 'Accessibility Standards Compliance', type: 'file', value: '' },
    { key: 'commercial_zoning_approval_office', label: 'Commercial Zoning Approval', type: 'file', value: '' },
    { key: 'fire_safety_approval_multi_storey', label: 'Enhanced Fire Safety Approval for multi-storey setups', type: 'file', value: '' },
    { key: 'accessibility_compliance_office', label: 'Accessibility Compliance', type: 'file', value: '' },
    { key: 'parking_plan_approval', label: 'Parking Plan Approval', type: 'file', value: '' },
    { key: 'electrical_load_approval', label: 'Electrical Load Approval for office-specific infrastructure', type: 'file', value: '' }
  ]
  EducationalFields = [
    { key: 'educational_board_standards_compliance', label: 'Educational Board Standards Compliance (e.g. class size, labs, playgrounds)', type: 'file', value: '' },
    { key: 'noc_department_of_education', label: 'NOC from Department of Education (DOE)', type: 'file', value: '' },
    { key: 'recognition_certificate_post_construction', label: 'Recognition Certificate after construction', type: 'file', value: '' },
    { key: 'affiliation_approval', label: 'Affiliation Approval (e.g. CBSE/ICSE)', type: 'file', value: '' }
  ]
  sanctionForm: FormGroup;
  stageFields = 'sanction';
  domainS = 'Commercial';
  ngOnInit() {
    const group: any = {};
    if (this.stageFields == 'sanction') {
      this.sanctionFields.forEach(field => {
        group[field.key] = new FormControl('');
      });
      this.sanctionForm = new FormGroup(group);

    } else if (this.stageFields == 'feasibility') {
      this.feasibilityFields.forEach(field => {
        group[field.key] = new FormControl('');
      });
      this.sanctionForm = new FormGroup(group);

    } else {
      this.completionFields.forEach(field => {
        group[field.key] = new FormControl('');
      });
      this.sanctionForm = new FormGroup(group);

    }
    if (this.domainS == 'Educational') {
      this.EducationalFields.forEach(field => {
        group[field.key] = new FormControl('');
      });
      this.sanctionForm = new FormGroup(group);
    } else {
      this.CommercialFields.forEach(field => {
        group[field.key] = new FormControl('');
      });
      this.sanctionForm = new FormGroup(group);
    }

    this.patchDummySanctionData();


  }

  patchDummySanctionData() {
    const patchObj: any = {};
    this.dummyData.forEach(item => {
      patchObj[item.key] = item.value;
    });
    this.sanctionForm.patchValue(patchObj);
  }

  onFileUpload(event: Event, key: string): void {
    const input = event.target as HTMLInputElement;
    if (input?.files && input.files.length > 0) {
      const file = input.files[0];


      this.sanctionForm.get(key)?.setValue(file.name);

      // Optional: Upload file to backend using FormData
      // const formData = new FormData();
      // formData.append('document', file);
      // this.http.post(`/upload/${key}`, formData).subscribe();
    }
  }

  getDownloadLink(filename: string): string {
    // return `assets/docs/${filename}`; 
    return filename;
  }


}
